export function parseSshAllowedCidrs(raw: string): string[] {
  const parts = raw.split(',').map(s => s.trim()).filter(s => s.length > 0)
  return parts.length === 0 ? [String.fromCharCode(42)] : parts
}
